module.exports = __webpack_public_path__ + "img/clinicIconB.5179cc06.svg";